import * as React from "react";

let CurrentClientContext = React.createContext({});
const ACTIVE_CLIENT_STORAGE_KEY = 'retailorbit.active_client'

function readStoredClient() {
  try {
    const rawValue = window.localStorage.getItem(ACTIVE_CLIENT_STORAGE_KEY)
    if (!rawValue) {
      return {}
    }

    const parsedValue = JSON.parse(rawValue)
    return parsedValue && typeof parsedValue === 'object' ? parsedValue : {}
  } catch (error) {
    console.warn('Unable to read stored client context:', error)
    return {}
  }
}

function writeStoredClient(nextClient) {
  try {
    if (nextClient && Object.keys(nextClient).length > 0) {
      window.localStorage.setItem(ACTIVE_CLIENT_STORAGE_KEY, JSON.stringify(nextClient))
      return
    }

    window.localStorage.removeItem(ACTIVE_CLIENT_STORAGE_KEY)
  } catch (error) {
    console.warn('Unable to persist client context:', error)
  }
}

function Provider(props) {
  let [client, setClientState] = React.useState(() => readStoredClient());

  const setClient = React.useCallback((nextClient) => {
    const resolvedClient = nextClient && typeof nextClient === 'object' ? nextClient : {}
    writeStoredClient(resolvedClient)
    setClientState(resolvedClient)
  }, [])

  let inject = {
    client,
    setClient,
  }
  return <CurrentClientContext.Provider value={inject}>{props.children}</CurrentClientContext.Provider>;
}

function useClient() {
  return React.useContext(CurrentClientContext)
}

export default {
  Provider,
  useClient,
}
